import { namespaceConfig } from 'fast-redux'

type RegisterState = {
  register_info: any
}

const DEFAULT_STATE: RegisterState = {
  register_info: {}
}

const { action, getState } = namespaceConfig('live_admin', DEFAULT_STATE)
const getRegisterState = (state: RegisterState): RegisterState=> getState(state)


export const getRegisterInfo = (state: RegisterState) => getRegisterState(state)?.register_info

export const setRegisterInfo = action('setRegisterInfo', function (state: RegisterState, register_info: any) {
    return { ...state, register_info: {...register_info} }
})